import { pitchByID, pitchFeature, pitchList, pitchRecommend, pitchUnfeature, pitchUpdate } from '@/services/ventures/pitches.service'

export default {
	namespaced: true,
	state: {
		pitchList: { meta: { pagination: { total: 0 } } },
		pitch: {},
		pitchStatus: 'pending',
		pitchSaveStatus: 'init',
	},
	getters: {
		getPitchList: s => s.pitchList,
		getPitch: s => s.pitch,
		getPitchStatus: s => s.pitchStatus,
		getPitchSaveStatus: s => s.pitchSaveStatus,
	},
	mutations: {
		PITCH_LIST(state, value) { state.pitchList = value },
		SET_PITCH(state, value) { state.pitch = value },
		PITCH_STATUS(state, value) { state.pitchStatus = value },
		PITCH_SAVE_STATUS(state, value) { state.pitchSaveStatus = value },
	},
	actions: {
		async fetchPitchList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PITCH_STATUS', 'pending')
			commit('PITCH_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await pitchList(params)
				commit('PITCH_STATUS', 'init')
				commit('PITCH_LIST', data)
				return data
			} catch (error) {
				commit('PITCH_STATUS', 'init')
				throw error
			}
		},
		async fetchPitchByID({ commit }, params) {
			commit('PITCH_STATUS', 'pending')
			try {
				const { data } = await pitchByID(params)
				commit('PITCH_STATUS', 'init')
				commit('SET_PITCH', data.data)
				return data
			} catch (error) {
				commit('PITCH_STATUS', 'init')
				return error
			}
		},
		async updatePitch({ commit }, params) {
			commit('PITCH_SAVE_STATUS', 'pending')
			try {
				const { data } = await pitchUpdate(params)
				commit('PITCH_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PITCH_SAVE_STATUS', 'init')
				throw error
			}
		},
		async featurePitch({ commit }, id) {
			try {
				const { data } = await pitchFeature(id)
				return data
			} catch (error) {
				throw error
			}
		},
		async unfeaturePitch({ commit }, id) {
			try {
				const { data } = await pitchUnfeature(id)
				return data
			} catch (error) {
				throw error
			}
		},
		async recommendPitch({ commit }, { id, ...params }) {
			try {
				const { data } = await pitchRecommend(id, params)
				return data
			} catch (error) {
				throw error
			}
		},
	},
}
